import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import styles from "./select.module.css";
import CustomSelect from "./CustomSelect";

const Select = forwardRef(
  (
    {
      className,
      onChange,
      name,
      id,
      placeholder,
      error,
      value,
      options = [],
      optionsValue,
      optionsText,
      fullWidth,
      ...props
    },
    ref
  ) => {
    return (
      <div className={styles.Select}>
        <select
          ref={ref}
          className={`${className} ${error ? styles.errorInput : ""} ${
            fullWidth ? styles.fullWidth : ""
          }`}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          {...props}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options.map((o, i) => (
            <option key={i} value={optionsValue ? optionsValue(o) : o}>
              {optionsText ? optionsText(o) : o}
            </option>
          ))}
        </select>
        {error && <small className="errorInput">{error}</small>}
      </div>
    );
  }
);
Select.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.array.isRequired,
  optionsValue: PropTypes.func,
  optionsText: PropTypes.func,
  fullWidth: PropTypes.bool,
};

export { CustomSelect };

export default Select;
